import { createApi } from '@reduxjs/toolkit/query/react';

import authedQuery from '@/services/authed.query';
import { ListOrganizationsResponse } from '@/services/api.types';

// Organization read surface. The batch-016 sibling mutation
// (POST /v1/organizations/sync, the FE-initiated FKO sync) is RETIRED —
// FKA org delimitation moved the reconcile server-side into the login itself,
// and the endpoint is gone with it.
const organizationApi = createApi({
  reducerPath: 'organizationApi',
  baseQuery: authedQuery,
  tagTypes: ['Organization'],
  endpoints: builder => ({
    // GET /v1/organizations — the full organisation list + the caller's
    // bindings in one shot, so the default filter cannot observe a skew
    // between the list and the bindings that index into it.
    getOrganizations: builder.query<ListOrganizationsResponse, void>({
      query: () => ({
        url: '/v1/organizations',
        method: 'GET',
      }),
      providesTags: [{ type: 'Organization', id: 'LIST' }],
    }),
  }),
});

export const { useGetOrganizationsQuery } = organizationApi;

export default organizationApi;
